export default {
    activeConversation: state => state.conversations
        .find(conversation => conversation.id === state.activeConversationId),

    conversations: state => state.conversations,

    isLoadingConversation: state => state.isLoadingConversation,

    isLoadingProjectEvents: state => state.isLoadingProjectEvents,

    isLoadingMessages: state => state.isLoadingMessages,

    isSendingMessage: state => state.isSendingMessage,

    shouldDisplayTypingEvent: state => state.shouldDisplayTypingEvent,

    fileDummy: state => state.fileDummy,
};



// WEBPACK FOOTER //
// ./src/taskflex/conversations/store/_getters.js